import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import FeaturedWatches from '../components/FeaturedWatches';
import { motion, useScroll, useSpring } from 'framer-motion';
import '../styles/HomePage.css';

const HomePage = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>KAIN Watches Ankara | Rolex &amp; Lüks Saat Satış · Alış</title>
        <meta
          name="description"
          content="Ankara Rolex satış, Ankara Rolex alış, lüks saat sat Ankara, Ankara lüks saat satış ve alış. KAIN Watches — güvenilir lüks saat alım satım, değerleme. @kainwatches"
        />
        <link rel="canonical" href="https://kainsaat.com/" />
      </Helmet>
      <motion.div className="progress-bar" style={{ scaleX }} />
      <div className="home-atmosphere">
        <Hero />
        <FeaturedWatches />
      </div>
    </>
  );
};

export default HomePage; 